// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._24aiW{max-width:1248px;max-width:78rem;margin-right:auto;margin-left:auto}@media(max-width:1439px){._24aiW{max-width:calc(100% - 4rem)}}@media(max-width:767px){._24aiW{max-width:calc(100% - 2rem)}}._1gTdM{overflow-wrap:break-word;margin-bottom:1rem}._10Jpb{-ms-flex:2 1;flex:2 1;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}@media(min-width:1024px){._10Jpb{grid-gap:1rem;gap:1rem}}@media(max-width:1023px){._10Jpb{-ms-flex-direction:column;flex-direction:column}}._2mDBb{width:100%;position:relative;-ms-flex:2 1;flex:2 1}@media(min-width:768px)and (max-width:1023px){._2mDBb{margin-bottom:1.5rem}}@media(max-width:767px){._2mDBb{margin-bottom:.75rem}}._2mDBb:before{content:\"\";display:block;width:100%;padding-bottom:56.25%}._3ET0o{background-color:#231815;position:absolute;top:0;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box}._1Y8zU{-ms-flex:1 1;flex:1 1;position:relative;color:#595757;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;grid-gap:16px;gap:16px;grid-gap:1rem;gap:1rem}._24aiW+._24aiW{margin-left:auto}@media(min-width:1024px){._28Z40{display:none}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"button": "_24aiW",
	"title": "_1gTdM",
	"videoWrapper": "_10Jpb",
	"videoPlayer": "_2mDBb",
	"player": "_3ET0o",
	"playlistWrapperOuter": "_1Y8zU",
	"continueLearningButton": "_28Z40"
};
module.exports = exports;
